export const environment = {
  production: false,
  'PRODUCTION': 'false',
  'ZONEIQ_CALIBRATION': 'https://zoning-calibration.gridics.com',
  'ZONEIQ_AUTHORIZATION_SERVICE': 'https://zoning-auth.gridics.com',
  'SHOW_VALIDATE_BUTTON': ''
};
